import { ObjectMap } from '@df/common';
const replacer = (_key, value) => {
    if (value instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(value.entries()),
        };
    }
    if (value instanceof ObjectMap) {
        return {
            dataType: 'ObjectMap',
            value: Array.from(value.entries()),
        };
    }
    if (value instanceof Set) {
        return {
            dataType: 'Set',
            value: Array.from(value),
        };
    }
    return value;
};
export { replacer };
